exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-delete-touch[data-v-63906898]{display:none}@media (hover:none){.btn-delete-touch[data-v-63906898]{display:inline-block}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63906898","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/admin/js/attendance/modals/WorkDayModalForm.vue
// module id = gz1c
// module chunks = 0